import axios from "axios";
import { logout, setSessionExpired } from "../redux/auth/authSlice";
import { store } from "../redux/store"; // Import your Redux store

// Utility function to handle logout
const handleLogout = () => {
  const dispatch = store.dispatch; // Access the store's dispatch method
  dispatch(logout());
};


// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API's base URL, e.g., process.env.REACT_APP_API_URL
  // timeout: 10000, // Optional timeout
});


// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify request before it is sent
    const token = localStorage.getItem("authToken"); // Example: get token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  },
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Handle response data
    return response;
  },
  (error) => {
    console.log("error.response?.status found", error.response?.status);
    // Handle response errors
    if (error.response?.status === 406) {
      store.dispatch(setSessionExpired(true));
    } else if (error.response?.status === 403 || error.response?.status === 401) {
      // Call the logout utility function
      handleLogout();
      // Example: Redirect to login on 401
      window.location.href = "/login";
    }

    if (error.response?.status === 429) {
      error.message = error.response?.data?.error;
    }
    
    return Promise.reject(error);
  },
);

export default axiosInstance;
